import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supportService } from "@/services/supportService";

export function useMyTickets() {
  return useQuery({ queryKey: ["my-tickets"], queryFn: supportService.myTickets });
}

export function useCreateTicket(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: supportService.createTicket,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["my-tickets"] });
      options.onSuccess?.(...args);
    },
  });
}
